import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "../auth/SessionContext.jsx";

/**
 * Frontend route boundary. This only decides whether a session token is
 * present  -  it never decides *what* a signed-in user is allowed to see.
 * Role/data-scope enforcement always happens on the backend; screens behind
 * this guard must still call permission-checked APIs. Reads session state
 * from SessionContext (not sessionStorage directly) so sign-out re-renders
 * this guard immediately instead of waiting for a page refresh.
 *
 * Unauthenticated visitors are redirected to the real /login route (not
 * rendered inline at whatever path they were on) so the address bar always
 * reflects the actual state of the app, per the slash-URL route contract.
 * The original destination is preserved in navigation state so a future
 * login form can send the user back where they were headed.
 */
export default function RouteGuard({ children }) {
  const { isAuthenticated } = useSession();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
